import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { store } from "./app/store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { initializeRouting } from "./app/services/routing";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { theme } from "./theme";

// Get the CSP nonce from the HTML template (if available!)
const getNonce = () => {
    const metaNonce = document.querySelector('meta[property="csp-nonce"]')?.getAttribute('content');

    if (metaNonce && metaNonce !== 'NONCE_PLACEHOLDER') {
        return metaNonce;
    }

    // Try to get nonce from script tag
    const scriptNonce = (document.currentScript as HTMLScriptElement)?.nonce ||
                       (document.querySelector('script[nonce]') as HTMLScriptElement)?.nonce;

    return scriptNonce || undefined;
};

// Create Emotion cache with nonce support!
const emotionCache = createCache({
    key: 'mui',
    nonce: getNonce(),
    prepend: true  // Ensures MUI styles are injected first
});

const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
    <React.StrictMode>
        <CacheProvider value={emotionCache}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <Provider store={store}>
                    <App />
                </Provider>
            </ThemeProvider>
        </CacheProvider>
    </React.StrictMode>
);

// Set up the routing handler, which will update state.routing whenever the
// location in the user's browser changes.
initializeRouting(store.dispatch);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
